export default __webpack_public_path__ + "static/media/bgvideo.396f5f72.mp4";